import { render, staticRenderFns } from "./TableRowNumOpportunitiesToGeneratePurchase.vue?vue&type=template&id=076202b2&lang=pug&"
import script from "./TableRowNumOpportunitiesToGeneratePurchase.vue?vue&type=script&lang=js&"
export * from "./TableRowNumOpportunitiesToGeneratePurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076202b2')) {
      api.createRecord('076202b2', component.options)
    } else {
      api.reload('076202b2', component.options)
    }
    module.hot.accept("./TableRowNumOpportunitiesToGeneratePurchase.vue?vue&type=template&id=076202b2&lang=pug&", function () {
      api.rerender('076202b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowNumOpportunitiesToGeneratePurchase.vue"
export default component.exports